<template>
  <message-dialog
    v-model="dialogOpen"
    title="Confirm"
    width="550px"
    @hide="$emit('hide')"
  >
    <q-item-label>Are you sure you want to delete this appointment?</q-item-label>

    <template #after>
      <page-banner
        dense
        dark
        color="red-7"
        class="q-mx-sm"
        content-classes="text-bold"
        label="This action cannot be undone. All information about this appointment will be deleted."
      />

      <q-list v-if="recurring">
        <q-separator inset />
        <q-item-label class="text-bold q-px-md q-pt-md">
          This appointment is part of a recurring rule.
        </q-item-label>
        <q-item>
          <q-item-section>
            <q-option-group
              v-model="deleteAction"
              :options="deleteOptions"
              type="radio"
            />
          </q-item-section>
        </q-item>
      </q-list>
    </template>

    <template #actions>
      <q-btn
        v-close-popup
        flat
        label="Cancel"
      />
      <q-btn
        v-close-popup
        flat
        label="Continue"
        autofocus
        color="red"
        @click="$emit('delete', deleteAction)"
      />
    </template>
  </message-dialog>
</template>

<script>
export default {
  props: {
    recurring: {
      type: Boolean,
      default: false
    }
  },
  emits: ['hide', 'delete'],
  data () {
    return {
      dialogOpen: false,
      deleteAction: 'none',
      deleteOptions: [
        { label: 'Do not delete recurring appointments', value: 'none' },
        { label: 'Delete unscheduled recurring appointments after this appointment date', value: 'unscheduled' },
        { label: 'Delete scheduled and unscheduled recurring appointments after this appointment date', value: 'all' }
      ]
    }
  },
  methods: {
    open () {
      this.dialogOpen = true
      this.deleteAction = 'none'
    }
  }
}
</script>
